import Debug from '@/util/debug';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import icons from '@/util/icons';
import Loading from '@/components/loading/Loading.vue';
import markdown from '@/components/markdown/Markdown.vue';

const breakpointTablet = 767;
const breakpointMobile = 575;

const debug = Debug('service:Examples'); // eslint-disable-line

export default {
  dependencies: ['exampleService', 'advantagesService', 'FAQService', 'genericConfigService', 'localeService'],
  components: {
    markdown,
    swiper,
    'swiper-slide': swiperSlide,
    loading: Loading,
  },
  data() {
    return {
      distanceUnit: 'km',
      tabIndex: 0,
      loading: false,
      examples: null,
      advantages: null,
      faq: null,
      error: null,
      selected: {
        examples: 0,
        advantages: 0,
        faq: 0,
      },
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
          [breakpointTablet]: {
            slidesPerView: 2.6,
            spaceBetween: 30,
          },
          [breakpointMobile]: {
            slidesPerView: 1.5,
            spaceBetween: 30,
          },
        },
      },
      formatSwiperOptions: {
        nextButton: '.button.button-mobile',
        prevButton: '.button.button-desktop',
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
      },
      icons,
      language: null,
    };
  },
  computed: {
    tabs() {
      const res = {};
      if (this.examples && this.examples.length) {
        res.examples = 'pos.examples.tabs.examples';
      }
      if (this.advantages && this.advantages.length) {
        res.advantages = 'pos.examples.tabs.advantages';
      }
      if (this.faq && this.faq.length) {
        res.faq = 'pos.examples.tabs.faq';
      }
      return res;
    },
  },
  mounted() {
    const fin = () => {
      this.loading = false;
      this.setActiveTabFromRoute();
    };

    this.localeService.getUserLanguage().then(language => this.language = language);
    this.localeService.getEventBus().$on('language-changed', language => this.language = language);

    this.loading = true;

    Promise.all(([
      this.exampleService.getExamples().then(res => {
        this.examples = res.map((e, idx) => {
          e.value = idx;
          e.text = e.name;
          return e;
        });
      }),
      this.advantagesService.getAdvantages().then(res => {
        this.advantages = res.map((adv, idx) => {
          adv.value = idx;
          adv.text = adv.name;
          return adv;
        });
      }),
      this.FAQService.getFAQ().then(res => {
        this.faq = res.map((adv, idx) => {
          adv.value = idx;
          adv.text = adv.name;
          return adv;
        });
      }),
      this.genericConfigService.getConfig().then(c => {
        this.distanceUnit = c.distance_unit;
      }),
    ]))
    .then(fin)
    .catch(err => { this.error = err; fin(); });
  },
  methods: {
    triggerUpdate() {
      // Swiper isn't loaded with page, this fixes swiper slide position
      if (this.$refs.advantagesSwiper) {
        this.$nextTick(() => {
          this.$refs.advantagesSwiper[0].swiper.update();
        });
      }
    },
    setActiveTabFromRoute() {
      const routeTab = this.$route.params.tab ? this.$route.params.tab : Object.keys(this.tabs)[0];
      this.tabIndex = Object.keys(this.tabs).indexOf(routeTab);
      if (this.tabIndex < 0 || this.tabIndex >= this.tabs.length) {
        this.tabIndex = 0;
      }
    },
    onTabChanged(value) {
      const tabKey = Object.keys(this.tabs)[value];
      this.$router.replace({ name: 'examples', params: { tab: tabKey } });
    },
    getLocalizedImages(defaultImages, localizedImages, getFirstImage = false) {
      let usedImages = defaultImages;
      if (typeof localizedImages[this.language] !== 'undefined') {
        usedImages = localizedImages[this.language];
      }
      if (getFirstImage && usedImages && usedImages.length > 0) {
        return usedImages[0];
      }
      return usedImages;
    },
  },
  watch: {
    'selected.advantages': function selectedAdvantages(index) {
      if (this.$refs.advantagesSwiper) {
        this.$refs.advantagesSwiper[0].swiper.slideTo(index);
      }
    },
    $route() {
      this.setActiveTabFromRoute();
    },
  },
  beforeDestroy() {
    this.localeService.getEventBus().$off('language-changed', language => this.language = language);
  },
};



// WEBPACK FOOTER //
// ./src/components/examples/Examples.js